import { render, staticRenderFns } from "./News2.vue?vue&type=template&id=766c6e6e&scoped=true"
import script from "./News2.vue?vue&type=script&lang=js"
export * from "./News2.vue?vue&type=script&lang=js"
import style0 from "./News2.vue?vue&type=style&index=0&id=766c6e6e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766c6e6e",
  null
  
)

export default component.exports